


import React, { Fragment } from "react";
import { useAccordionObjectFieldContext, IAccordionObjectFieldContext } from "./AccordionObjectFieldContext";

type IRenderProps = IAccordionObjectFieldContext;

interface RenderAccordionProps {
    render: (props: IRenderProps) => any;
};

export const RenderAccordion: React.FC<RenderAccordionProps> = ({ render }) => {
    const context = useAccordionObjectFieldContext();

    if (!context) {
        return <div>Failed to render accordion</div>
    };

    return (
        <Fragment>
            {render(context)}
        </Fragment>
    );
};

